import React from 'react'

export const ListHeader = () => {
  return (
    <thead>
      <tr>
        <th>Carrier name</th>
        <th>Service type</th>
        <th>Delivery days</th>
        <th>Estimated delivery date</th>
        <th>Amount</th>
      </tr>
    </thead>
  )
}
